"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Level = _interopRequireDefault(require("./Level1"));
var _Level2 = _interopRequireDefault(require("./Level2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class VerticalMenu extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleLinkActive", (match, link) => {
      if (match) {
        if (this.state.activeLink !== link) this.setState({
          activeLink: link
        });
      }
      if (!match) {
        if (this.state.activeLink === link && this.state.activeLink !== null) this.setState({
          activeLink: null
        });
      }
    });
    _defineProperty(this, "handleMenuWidth", (level, state) => {
      localStorage.setItem(level, state);
      let menuStateChange = {};
      menuStateChange[level] = state;
      this.setState(menuStateChange);
    });
    let level1Expanded;
    let level2Expanded;
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || 1400;
    if (windowWidth < 1500) {
      level1Expanded = localStorage.getItem("level1Expanded") === "true" ? true : false;
      level2Expanded = localStorage.getItem("level2Expanded") === "true" ? true : false;
    } else if (1500 < windowWidth && windowWidth < 1800) {
      level1Expanded = localStorage.getItem("level1Expanded") === "false" ? false : true;
      level2Expanded = localStorage.getItem("level2Expanded") === "true" ? true : false;
    } else {
      level1Expanded = localStorage.getItem("level1Expanded") === "false" ? false : true;
      level2Expanded = localStorage.getItem("level2Expanded") === "false" ? false : true;
    }
    localStorage.setItem("level1Expanded", level1Expanded);
    localStorage.setItem("level2Expanded", level2Expanded);
    this.state = {
      activeLink: null,
      level1Expanded: level1Expanded,
      level2Expanded: level2Expanded
    };
  }
  render() {
    const {
      auth,
      SignOut,
      history,
      account,
      links
    } = this.props;
    const {
      activeLink,
      level1Expanded,
      level2Expanded
    } = this.state;
    let allowedLevel1Links = auth.me.helpers ? links.filter(link => auth.me.helpers.isAllowed(link.restricted)) : links;
    let allowedLevel2Links = !activeLink ? null : auth.me.helpers ? activeLink.links && activeLink.links.filter(link => auth.me.helpers.isAllowed(link.restricted)) : null;
    if (allowedLevel2Links) {
      if (allowedLevel2Links.length <= 1) allowedLevel2Links = null;
    }
    const authenticated = auth.state === "LOGGED_IN";
    const loggedOut = auth.state === "LOGGED_OUT";
    const maintenance = auth.state === "MAINTENANCE_MODE";
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "menu shadow"
    }, /*#__PURE__*/_react.default.createElement(_Level.default, {
      me: auth.me.fetched ? auth.me.data : null,
      authenticated: authenticated,
      maintenance: maintenance,
      loggedOut: loggedOut,
      links: allowedLevel1Links,
      expanded: level1Expanded,
      onLinkActive: this.handleLinkActive,
      history: history,
      account: account,
      name: auth.config.name,
      onToggle: state => this.handleMenuWidth("level1Expanded", state)
    }), authenticated && /*#__PURE__*/_react.default.createElement(_Level2.default, {
      links: allowedLevel2Links,
      expanded: level2Expanded,
      onToggle: state => this.handleMenuWidth("level2Expanded", state)
    }));
  }
}
VerticalMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: _propTypes.default.object.isRequired
} : {};
VerticalMenu.defaultProps = {
  color: "",
  links: []
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(VerticalMenu);
module.exports = exports.default;